<template>
  <div class="dl-wrap">
    <div class="dl-container">
      <el-header style="width: 100%">
        <language-switch />
      </el-header>
      <div class="dl-content-base">
        <img src="../../assets/img/h6.jpg" alt="img" />
        <div class="dl-base-title">{{ getLanguageValue('工商业屋面') }}</div>
      </div>
      <div class="dl-content-item">
        <div class="dl-item-count">
          <el-form
            ref="form"
            :model="formBase"
            :rules="generateRules()"
            label-position="right"
            :label-width="formLabelWidth"
            :validate-on-rule-change="false"
          >
            <el-row>
              <el-col :span="12">
                <!-- <el-form-item  prop="type">
                                    <el-radio v-model="formBase.type" label="1" class="handle-radio">{{getLanguageValue('彩钢瓦屋面')}}</el-radio>
                                </el-form-item>
                                <el-form-item class="center">
                                    <img src="../../assets/img/h7.jpg" alt="img" class="handle-imgs">
                                </el-form-item> -->
                <div class="handle-imgs">
                  <el-radio v-model="formBase.type" label="1" class="handle-radio">{{ getLanguageValue('彩钢瓦屋面') }}</el-radio>
                </div>
                <div class="handle-imgs">
                  <img src="../../assets/img/h7.jpg" alt="img" />
                </div>

                <el-form-item :label="getLanguageValue('组件产品')" prop="viewProduct">
                  <div class="row-select-product flex-row">
                    <el-select style="width: 180px" v-model="formBase.componentId" clearable :placeholder="getLanguageValue('请选择产品名称')">
                      <el-option v-for="item in componentList" :key="item.id" :label="item.componentName" :value="item.id"> </el-option>
                    </el-select>

                    <el-select style="width: 180px" v-model="formBase.componentPowerId" clearable :placeholder="getLanguageValue('请选择功率(W)')">
                      <el-option v-for="item in componentPowerList" :key="item.id" :label="`${item.componentPower}W`" :value="item.id"> </el-option>
                    </el-select>
                    <el-button type="warning" @click="createNewProduct">{{ getLanguageValue('新建') }}</el-button>
                  </div>
                </el-form-item>

                <!-- <el-form-item :label="getLanguageValue('组件产品')" prop="viewProduct">
                                  <div class="flex-row">
                                    <el-select class="handle-select" @change="getCommercialProductList" v-model="formBase.viewProduct" clearable :placeholder="getLanguageValue('请选择')">
                                        <el-option
                                          v-for="item in formBase.optionViewProduct"
                                          :key="item.componentStandard"
                                          :label="getLanguageValue(item.componentStandard)"
                                          :value="item.id"
                                        >
                                          {{item.componentStandard}} 
                                          <template  v-if="item.id && String(item.id).startsWith('custom-')">
                                            <span class="edit-product" @click.stop="editCustomProduct(item)"> <i class="el-icon-edit" ></i></span>
                                          </template>
                                        </el-option>
                                    </el-select>
                                    <el-button type="warning" @click="createNewProduct" style="margin-left: 20px">{{getLanguageValue('新建')}}</el-button>
                                  </div>
                                </el-form-item> -->
                <el-form-item label-width="200px">
                  <div class="dl-content-block">
                    <div class="dl-block-img"><img :src="formBase.listData.imageUrl" alt="" /></div>
                    <div class="dl-block-item">
                      <div class="dl-block-text">
                        <div class="dl-text-title">{{ getLanguageValue('组件功率') }}:</div>
                        <div class="dl-text-unit">{{ formBase.listData.componentPower }}W</div>
                      </div>
                      <div class="dl-block-text">
                        <div class="dl-text-title">{{ getLanguageValue('电池类型') }}:</div>
                        <div class="dl-text-unit">{{ formBase.listData.batterShow }}</div>
                      </div>
                      <div class="dl-block-text">
                        <div class="dl-text-title">{{ getLanguageValue('单/双玻') }}:</div>
                        <div class="dl-text-unit">{{ getLanguageValue(formBase.listData.singleDou) }}</div>
                      </div>
                      <div class="dl-block-text">
                        <div class="dl-text-title">{{ getLanguageValue('组件寿命') }}:</div>
                        <div class="dl-text-unit">{{ formBase.listData.lifeTime }}{{ getLanguageValue('年') }}</div>
                      </div>
                      <div class="dl-block-text">
                        <div class="dl-text-title">{{ getLanguageValue('组件长度') }}:</div>
                        <div class="dl-text-unit">{{ formBase.listData.componentHigh }}m</div>
                      </div>
                      <div class="dl-block-text">
                        <div class="dl-text-title">{{ getLanguageValue('组件宽度') }}:</div>
                        <div class="dl-text-unit">{{ formBase.listData.componentWidth }}m</div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- <el-form-item prop="type">
                                    <el-radio v-model="formBase.type" label="2" class="handle-radio">{{getLanguageValue('混凝土屋面')}}</el-radio>
                                </el-form-item>
                                <el-form-item class="center">
                                    <img src="../../assets/img/h8.jpg" alt="img" class="handle-imgs">
                                </el-form-item> -->

                <div class="handle-imgs">
                  <el-radio v-model="formBase.type" label="2" class="handle-radio">{{ getLanguageValue('混凝土屋面') }}</el-radio>
                </div>
                <div class="handle-imgs">
                  <img src="../../assets/img/h8.jpg" alt="img" />
                </div>
                <el-form-item :label="getLanguageValue('组件价格(元/瓦)')" prop="price">
                  <el-input
                    class="handle-input"
                    v-model="formBase.price"
                    :placeholder="`${getLanguageValue('建议价格')}${formBase.listData.componentPrice}${getLanguageValue('元/瓦')}`"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('省份')" prop="province">
                  <el-select
                    class="handle-select"
                    @change="getCityData"
                    v-model="formBase.province"
                    clearable
                    :placeholder="getLanguageValue('请选择')"
                  >
                    <el-option
                      v-for="item in formBase.optionProvince"
                      :key="item.province"
                      :label="getLanguageValue(item.province)"
                      :value="item.province"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="getLanguageValue('城市')" prop="city">
                  <el-select class="handle-select" v-model="formBase.city" clearable :placeholder="getLanguageValue('请选择')">
                    <el-option v-for="item in formBase.optionCity" :key="item.city" :label="getLanguageValue(item.city)" :value="item.city">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="getLanguageValue('屋面面积(平米)')" prop="roofArea">
                  <el-input class="handle-input" v-model="formBase.roofArea" :placeholder="getLanguageValue('请输入内容')"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('装机容量计算方式')" prop="capacityCalcType">
                  <el-select class="handle-select" v-model="formBase.capacityCalcType" clearable :placeholder="getLanguageValue('请选择')">
                    <el-option v-for="item in formBase.optionCostWay" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="formBase.capacityCalcType !== '自动计算'" :label="getLanguageValue('装机容量(KW)')" prop="installCapacity">
                  <el-input class="handle-input" v-model="formBase.installCapacity" :placeholder="getLanguageValue('请输入')"></el-input>
                </el-form-item>

                <el-form-item :label="getLanguageValue('建设投资方式')" prop="invest" v-else>
                  <el-select class="handle-select" v-model="formBase.invest" clearable :placeholder="getLanguageValue('请选择')">
                    <el-option v-for="item in formBase.optionInvest" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="two-columns">
              <el-form-item :label="getLanguageValue('建设投资方式')" prop="invest" v-if="formBase.capacityCalcType !== '自动计算'">
                <el-select class="handle-select" v-model="formBase.invest" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option v-for="item in formBase.optionInvest" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- 建设投资方式选择自建时不展示 -->
              <el-form-item :label="getLanguageValue('屋顶租金(元/平米)')" prop="roofRent" v-if="formBase.invest !== '自建'">
                <el-input class="handle-input" v-model="formBase.roofRent" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('自用电价(元/度)')" prop="elecPrice">
                <el-input class="handle-input" v-model="formBase.elecPrice" :placeholder="getLanguageValue('请输入')"></el-input>
              </el-form-item>
              <!-- 建设投资方式选择自建时不展示 -->
              <el-form-item :label="getLanguageValue('电价优惠(%)')" prop="elecDiscount" v-if="formBase.invest !== '自建'">
                <el-input class="handle-input" v-model="formBase.elecDiscount" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('光伏发电自用消纳率(%)')" prop="elecPower">
                <el-input class="handle-input" v-model="formBase.elecPower" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('并网电压(kV)')" prop="voltage">
                <el-select class="handle-select" v-model="formBase.voltage" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option v-for="item in formBase.optionVoltage" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="getLanguageValue('安装倾角(°)')" prop="angle">
                <el-tooltip effect="dark" :content="`备注：最佳倾角 ${bestDip}°`" :value="!!bestDip" placement="right" :manual="true">
                  <el-input-number v-model="formBase.angle" :min="0" :max="45"></el-input-number>
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="getLanguageValue('系统造价计算方式')" prop="costWay">
                <el-select class="handle-select" v-model="formBase.costWay" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option v-for="item in formBase.optionCostWay" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="getLanguageValue('系统造价(元/瓦)')" v-if="formBase.costWay == '用户填写'" prop="cost">
                <el-input class="handle-input" v-model="formBase.cost" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('上网电价设置')" prop="hasInternetPrice">
                <el-select class="handle-select" v-model="formBase.hasInternetPrice" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option :label="getLanguageValue('用户设置')" value="用户设置"></el-option>
                  <el-option :label="getLanguageValue('自动提取')" value="自动提取"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="getLanguageValue('上网电价')" v-if="formBase.hasInternetPrice == '用户设置'" prop="internetPrice">
                <el-input
                  class="handle-input"
                  :min="0"
                  type="number"
                  v-model="formBase.internetPrice"
                  :placeholder="getLanguageValue('请输入内容')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('计算组件串联块数是否对开路电压进行修正')" prop="corrected">
                <el-select class="handle-select" v-model="formBase.corrected" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option :label="getLanguageValue('是')" value="是"></el-option>
                  <el-option :label="getLanguageValue('否')" value="否"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="two-columns">
              <el-form-item :label="getLanguageValue('是否配置储能系统')" prop="energyStorage">
                <el-select class="handle-select" v-model="formBase.energyStorage" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option v-for="item in formBase.optionStatuses" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="two-columns" v-if="formBase.energyStorage == '是'">
              <el-form-item :label="getLanguageValue('储能配置容量与装机容量的百分比(%)')" prop="capacityRate">
                <el-input class="handle-input" v-model="formBase.capacityRate" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能配置时间(h)')" prop="essTime">
                <el-input class="handle-input" v-model="formBase.essTime" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('是否利用光伏发电')" prop="isCharge">
                <el-select class="handle-select" v-model="formBase.isCharge" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option v-for="item in formBase.optionCharge" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能第1次充电电价(元/度)')" prop="chargePrice">
                <el-input class="handle-input" v-model="formBase.chargePrice" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能第1次放电电价(元/度)')" prop="dischargePriceOne">
                <el-input class="handle-input" v-model="formBase.dischargePriceOne" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能第2次充电电价(元/度)')" prop="chargePriceTwo">
                <el-input
                  class="handle-input"
                  :min="0"
                  type="number"
                  v-model.number="formBase.chargePriceTwo"
                  :placeholder="getLanguageValue('请输入内容')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能第2次放电电价(元/度)')" prop="dischargePriceTwo">
                <el-input class="handle-input" v-model="formBase.dischargePriceTwo" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能是否有补贴')" prop="isEssSubsidy">
                <el-select class="handle-select" v-model="formBase.isEssSubsidy" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option v-for="item in formBase.optionEssSubsidy" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能装机补贴(元/KWH)')" v-if="formBase.isEssSubsidy == '有'" prop="essSubsidy">
                <el-input class="handle-input" v-model="formBase.essSubsidy" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能放电补贴(元/度)')" v-if="formBase.isEssSubsidy == '有'" prop="dischargeSubsidy">
                <el-input class="handle-input" v-model="formBase.dischargeSubsidy" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能装机补贴最高额度(万元)')" v-if="formBase.isEssSubsidy == '有'" prop="essSubsidyMax">
                <el-input class="handle-input" v-model="formBase.essSubsidyMax" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能放电补贴最高额度(万元)')" v-if="formBase.isEssSubsidy == '有'" prop="dischargeSubsidyMax">
                <el-input class="handle-input" v-model="formBase.dischargeSubsidyMax" :placeholder="getLanguageValue('请输入内容')"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能放电补贴年限(年)')" v-if="formBase.isEssSubsidy == '有'" prop="dischargeSubsidyYear">
                <el-input
                  class="handle-input"
                  v-model.number="formBase.dischargeSubsidyYear"
                  :placeholder="getLanguageValue('请输入内容')"
                ></el-input>
              </el-form-item>

              <!-- 新增字段 -->
              <el-form-item :label="getLanguageValue('储能一充一放月数')" prop="oneChargeMonth">
                <el-input
                  class="handle-input"
                  v-model.number="formBase.oneChargeMonth"
                  :placeholder="getLanguageValue('请输入内容')"
                  @blur="triggerRelatedValidation('twoChargeMonth')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('储能两充两放月数')" prop="twoChargeMonth">
                <el-input
                  class="handle-input"
                  v-model.number="formBase.twoChargeMonth"
                  :placeholder="getLanguageValue('请输入内容')"
                  @blur="triggerRelatedValidation('oneChargeMonth')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('第十年末是否更换储能电池')" prop="tenYearsReplaceBatter">
                <el-select class="handle-select" v-model="formBase.tenYearsReplaceBatter" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option :label="getLanguageValue('是')" value="是"></el-option>
                  <el-option :label="getLanguageValue('否')" value="否"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="two-columns">
              <el-form-item :label="getLanguageValue('是否有机制电价')" prop="hasElectPrice">
                <el-select class="handle-select" v-model="formBase.hasElectPrice" clearable :placeholder="getLanguageValue('请选择')">
                  <el-option v-for="item in formBase.optionStatuses" :key="item.value" :label="getLanguageValue(item.label)" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="two-columns" v-if="formBase.hasElectPrice == '是'">
              <el-form-item :label="getLanguageValue('机制电价价格(元/度)')" prop="electPrice">
                <el-input class="handle-input" v-model="formBase.electPrice" :placeholder="getLanguageValue('请输入内容')" type="number"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('机制电量占上网电量的百分比(%)')" prop="electRate">
                <el-input class="handle-input" v-model="formBase.electRate" :placeholder="getLanguageValue('请输入内容')" type="number"></el-input>
              </el-form-item>
              <el-form-item :label="getLanguageValue('机制电价年限(年)')" prop="electYear">
                <el-input
                  class="handle-input"
                  v-model="formBase.electYear"
                  :placeholder="getLanguageValue('请输入')"
                  @input="onIntegerInput('electYear')"
                  @keypress.native="onlyInt"
                ></el-input>
              </el-form-item>
            </div>

            <el-row>
              <el-col :span="12">&nbsp;</el-col>
              <el-col :span="12">
                <el-form-item class="center">
                  <el-button type="warning" @click="getFormCount('form')" :loading="loadingCount">{{
                    loadingCount ? getLanguageValue('计算中') : getLanguageValue('开始计算')
                  }}</el-button>
                  <el-button @click="handleReload">{{ getLanguageValue('重置') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="dl-item-result" v-if="showResult">
          <el-divider content-position="left">{{ getLanguageValue('计算结果') }}</el-divider>
          <div class="dl-item-list">
            <el-form label-position="top">
              <el-col :span="6">
                <el-form-item :label="getLanguageValue('组件数量(块)')">
                  <el-input class="handle-input-item" v-model="formResult.componentNum"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('25年发电利润总额(万)')">
                  <el-input class="handle-input-item" v-model="formResult.totalProfit"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('25年总发电量(万kWh)')">
                  <el-input class="handle-input-item" v-model="formResult.grossGeneration"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('减排硫氧化物排放量(吨)')">
                  <el-input class="handle-input-item" v-model="formResult.reductionSo"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('单玻产品混凝土屋面最佳倾角(°)')">
                  <el-input class="handle-input-item" v-model="formResult.dipOne"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="getLanguageValue('装机容量(千瓦)')">
                  <el-input class="handle-input-item" v-model="formResult.installedCapacity"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('全部投资内部收益率(%)')">
                  <el-input class="handle-input-item" v-model="formResult.investInternalRate"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('25年年均发电量(万kWh)')">
                  <el-input class="handle-input-item" v-model="formResult.avgGeneration"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('减排氮氧化物排放量(吨)')">
                  <el-input class="handle-input-item" v-model="formResult.reductionNo"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('双玻产品混凝土屋面最佳倾角(°)')">
                  <el-input class="handle-input-item" v-model="formResult.dipTwo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="getLanguageValue('建设投资(万)')">
                  <el-input class="handle-input-item" v-model="formResult.investBulid"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('首年等效利用小时数(H)')">
                  <el-input class="handle-input-item" v-model="formResult.firstEqualHours"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('减排标准煤消耗量(吨)')">
                  <el-input class="handle-input-item" v-model="formResult.reductionCoal"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('减排灰尘排放量(吨)')">
                  <el-input class="handle-input-item" v-model="formResult.reductionDust"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="getLanguageValue('投资回收期(年)')">
                  <el-input class="handle-input-item" v-model="formResult.investPayablePeriod"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('25年年均等效利用小时数(H)')">
                  <el-input class="handle-input-item" v-model="formResult.avgEqualHours"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('减排二氧化碳排放量(吨)')">
                  <el-input class="handle-input-item" v-model="formResult.reductionCo"></el-input>
                </el-form-item>
                <el-form-item :label="getLanguageValue('彩钢瓦屋面平铺最佳倾角(°)')">
                  <el-input class="handle-input-item" v-model="formResult.dipTile"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
          <div class="dl-item-foot">
            <div class="dl-foot-chart" id="leftChart1"></div>
            <div class="dl-foot-chart" id="rightChart1"></div>
          </div>
        </div>
      </div>
    </div>
    <v-foot></v-foot>
    <message-sild :logId="logId"></message-sild>

    <!-- 自定义组件规格新增or编辑 -->
    <create-product-dialog :visible.sync="addProductDialog" :detailInfo="editProductInfo" @submit="handleEditProduct" />
  </div>
</template>

<script>
import {
  CommercialProductList,
  CommercialProvince,
  CommercialCity,
  CommercialResult,
  calBusDipBest,
  getComponentSpecification,
  getComponentPower,
} from '@/api/index'
import vFoot from '../../components/foot-box.vue'
import MessageSild from '../../components/Message.vue'
import CreateProductDialog from './components/CreateProductDialog'
import LanguageSwitch from '../../components/language-switch'
import { mapGetters } from 'vuex'

export default {
  inject: ['reload'],
  components: {
    vFoot,
    MessageSild,
    CreateProductDialog,
    LanguageSwitch,
  },
  computed: {
    ...mapGetters('language', ['getLanguageValue']),
  },
  watch: {
    'formBase.type': 'calculationDipBest',
    'formBase.city': 'calculationDipBest',
    'formBase.listData.singleDou': 'calculationDipBest',
    'formBase.componentId': 'getComponentPowerList',
    'formBase.componentPowerId': {
      handler(val) {
        const listData_ = this.formBase?.listData || {}
        // 清空功率选择时，已选择自定义产品 不处理
        if (!val && listData_.id && `${listData_.id}`.startsWith('custom-')) {
          return
        }
        const { componentPowerList } = this
        const listData = componentPowerList.find((item) => item.id === val) || {}
        this.$set(this.formBase, 'listData', listData)
        this.$set(this.formBase, 'viewProduct', listData?.id || '')
        if (val) this.$set(this.formBase, 'price', listData?.componentPrice || '')
      },
      immediate: true,
    },
  },
  data() {
    return {
      loadingCount: false,
      bestDip: '', // 最佳倾角
      formBase: {
        type: '1', //工商业屋面 类型
        viewProduct: '', //组件产品id
        listData: {},
        elecPrice: '', //自用电价
        elecPower: '', //光伏发电自用消纳率
        angle: '1', //安装倾角
        energyStorage: '', //是否配置储能系统
        optionStatuses: [
          {
            label: '是',
            value: '是',
          },
          {
            label: '否',
            value: '否',
          },
        ],
        price: '', //组件价格
        province: '', //省份
        optionProvince: [],
        city: '', //城市
        optionCity: [],
        roofArea: '', //屋面面积
        capacityCalcType: '', // 装机容量计算方式
        installCapacit: '', // 装机容量(千瓦)
        invest: '', //建设投资方式
        optionInvest: [
          {
            label: '自建',
            value: '自建',
          },
          {
            label: '投资',
            value: '投资',
          },
        ],
        roofRent: '', //屋顶租金
        elecDiscount: '100', //电价折扣
        voltage: '', //并网电压
        optionVoltage: [
          {
            label: '10',
            value: '10',
          },
          {
            label: '0.4',
            value: '0.4',
          },
        ],
        costWay: '', //系统造价计算方式
        optionCostWay: [
          {
            label: '自动计算',
            value: '自动计算',
          },
          {
            label: '用户填写',
            value: '用户填写',
          },
        ],
        cost: '0', //系统造价

        capacityRate: '',
        essTime: '',
        chargePrice: '',
        isCharge: '',
        optionCharge: [
          {
            label: '是',
            value: '是',
          },
          {
            label: '否',
            value: '否',
          },
        ],

        dischargePriceOne: '',
        dischargePriceTwo: '',
        isEssSubsidy: '',
        optionEssSubsidy: [
          {
            label: '有',
            value: '有',
          },
          {
            label: '无',
            value: '无',
          },
        ],

        essSubsidy: '',
        dischargeSubsidy: '',
        dischargeSubsidyYear: '',
        dischargeSubsidyMax: '',
        essSubsidyMax: '',
        // dischargeCount:"",
        optionChargeCount: [
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
        ],

        hasElectPrice: '否', // 是否有机制电价
      },

      formResult: {},
      showResult: false,
      formLabelWidth: '200px',

      // 是否新建产品
      addProductDialog: false,
      editProductInfo: {},
      logId: '', // 咨询id

      componentList: [], // 组件名称列表
      componentPowerList: [], // 组件功率列表
    }
  },
  created() {
    console.log(document.body.clientWidth)
    if (document.body.clientWidth <= 1920) {
      this.formLabelWidth = '200px'
    } else if (document.body.clientWidth > 1920) {
      this.formLabelWidth = '400px'
    }
    this.getComponentList()
  },
  mounted() {
    this.getProvinceData()
  },
  methods: {
    onlyInt(e) {
      if (!/[0-9]/.test(e.key)) e.preventDefault()
    },
    onIntegerInput(field) {
      const val = String(this.formBase[field] || '')
      this.formBase[field] = val.replace(/[^\d]/g, '')
    },
    /**
     * 获取组件名称列表
     */
    getComponentList() {
      getComponentSpecification('cal-out-bus').then((res) => {
        this.componentList = res?.data || []
        this.$set(this.formBase, 'componentId', this.componentList.length > 0 ? this.componentList[0].id : '')
      })
    },
    /**
     * 获取组件功率列表
     */
    getComponentPowerList() {
      const { componentList } = this
      const componentId = this.formBase?.componentId || ''
      const componentName = componentList.find((item) => item.id === componentId)?.componentName || ''
      // 清空产品名称选择
      if (!componentId) {
        this.componentPowerList = []
        // 清空功率选择
        this.$set(this.formBase, 'componentPowerId', '')
        if (this.formBase.viewProduct && this.formBase.viewProduct.startsWith('custom-')) return
        this.$set(this.formBase, 'viewProduct', '')
        return
      }
      getComponentPower('cal-out-bus', { componentName }).then((res) => {
        this.componentPowerList = res?.data || []
        this.$set(this.formBase, 'componentPowerId', this.componentPowerList.length > 0 ? this.componentPowerList[0].id : '')
        if (this.formBase.viewProduct && this.formBase.viewProduct.startsWith('custom-')) return
        // 回填组件价格
        this.$set(this.formBase, 'price', this.componentPowerList.length > 0 ? this.componentPowerList[0].componentPrice : '')
        // 回填组件规格
        this.$set(this.formBase, 'viewProduct', this.componentPowerList.length > 0 ? this.componentPowerList[0].componentStandard : '')
      })
    },
    /**
     * 计算最佳倾角
     */
    async calculationDipBest() {
      // 屋顶类型
      const roofType = this.formBase?.type || ''
      // 省份
      const province = this.formBase?.province || ''
      // 城市
      const city = this.formBase?.city || ''
      // 单/双玻
      const singleDou = this.formBase?.listData?.singleDou || ''

      if (!roofType || !city || !singleDou) {
        this.bestDip = ''
        return
      }
      // 彩钢瓦屋面不展示最佳倾角
      if (roofType === '1') {
        this.bestDip = ''
        return
      }
      calBusDipBest({
        roofType: roofType == '1' ? '彩钢瓦屋面' : '混凝土屋面',
        province,
        city,
        singleDou,
      })
        .then((res) => {
          if (res.success) this.bestDip = res.data
          else this.bestDip = ''
        })
        .catch(() => {
          this.bestDip = ''
        })
    },
    generateRules() {
      return {
        type: [{ required: true, message: this.getLanguageValue('请输入'), trigger: 'change' }],
        viewProduct: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        price: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        elecPrice: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        elecPower: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        angle: [{ required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' }],
        energyStorage: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        province: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        city: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        roofArea: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        capacityCalcType: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        installCapacity: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        invest: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        roofRent: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        elecDiscount: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          {
            // pattern: /^(100|(\d{1,2}(\.\d{1,6})?))$/,
            pattern: /^-?\d+(\.\d{1,6})?$/,
            message: this.getLanguageValue('请输入正确的数值'),
            trigger: 'blur',
          },
        ],
        voltage: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        costWay: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        cost: [{ required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' }],
        capacityRate: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        essTime: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        chargePrice: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        isCharge: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        dischargePriceOne: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        dischargePriceTwo: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        isEssSubsidy: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        essSubsidy: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        dischargeSubsidy: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        dischargeSubsidyYear: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { type: 'number', message: '请输入正确的数值' },
          { pattern: /^([0-9]|[1-9]\d)$/, message: '范围在0-99之间', trigger: 'blur' },
        ],
        dischargeSubsidyMax: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        essSubsidyMax: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        // dischargeCount:[{ required: true, message: '请选择储能一天充放电次数', trigger: 'change' }],
        hasInternetPrice: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        internetPrice: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        corrected: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        oneChargeMonth: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          {
            pattern: /^\d+$/,
            message: this.getLanguageValue('请输入整数'),
            trigger: 'blur',
          },
          { validator: this.validateSum, trigger: 'blur' }, // 校验两者之和
        ],
        twoChargeMonth: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          {
            pattern: /^\d+$/,
            message: this.getLanguageValue('请输入整数'),
            trigger: 'blur',
          },
          { validator: this.validateSum, trigger: 'blur' }, // 校验两者之和
        ],
        chargePriceTwo: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: this.getLanguageValue('请输入6位小数位内的数字请输入') },
        ],
        tenYearsReplaceBatter: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],

        hasElectPrice: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
        electPrice: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        electRate: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' },
        ],
        electYear: [
          { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
          {
            pattern: /^\d+$/,
            message: this.getLanguageValue('请输入整数'),
            trigger: 'blur',
          },
        ],
      }
    },
    /**
     * 校验储能一充一放月数和储能两充两放月数的总和是否为12
     */
    validateSum(rule, value, callback) {
      const { oneChargeMonth, twoChargeMonth } = this.formBase
      const sum = Number(oneChargeMonth) + Number(twoChargeMonth)

      if (sum !== 12) {
        callback(new Error(this.getLanguageValue('储能一充一放月数和储能两充两放月数之和必须等于 12')))
      } else {
        callback()
      }
    },
    // 手动触发相关字段校验
    triggerRelatedValidation(field) {
      this.$refs.form.validateField(field) // 触发指定字段的校验
    },
    /**
     * 处理计算重置
     */
    handleReload() {
      this.logoId = ''
      this.reload()
    },
    handleEditProduct(info) {
      const id = `custom-${Date.now()}`
      this.$set(this.formBase, 'listData', Object.assign({}, info, { id }))
      this.$set(this.formBase, 'viewProduct', id)
      this.$set(this.formBase, 'componentId', '')
      this.$set(this.formBase, 'componentPowerId', '')
      this.$set(this.formBase, 'price', info.componentPrice)
      this.$refs.form.validateField('viewProduct')
    },
    // 新建产品
    createNewProduct() {
      this.addProductDialog = true
    },
    editCustomProduct(info) {
      this.addProductDialog = true
    },

    numberChange(val) {
      if (val > 1) {
        this.formBase.elecDiscount = 1
      } else {
        this.formBase.elecDiscount = val
      }
    },
    getProvinceData() {
      CommercialProvince().then((res) => {
        if (res.success) {
          this.formBase.optionProvince = res.data
        }
      })
    },
    getCityData(val) {
      this.formBase.city = ''
      CommercialCity({ province: val }).then((res) => {
        if (res.success) {
          this.formBase.optionCity = res.data
        }
      })
    },
    getLeftChart(data) {
      // console.log(data);
      const LeftChart = this.$echarts.init(document.getElementById('leftChart1'))
      const option = {
        title: {
          text: this.getLanguageValue('营业收入(万元)'),
          left: 'center',
          textStyle: {
            fontSize: '22',
            color: '#505050',
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
          axisPointer: {
            type: 'shadow',
          },
          axisLabel: {
            textStyle: {
              fontSize: 16,
              color: '#505050',
            },
          },
        },
        yAxis: {
          type: 'value',
          name: this.getLanguageValue('单位:万元'),
          nameTextStyle: {
            color: '#505050',
            fontSize: '16',
          },
          axisLabel: {
            //y轴文字的配置
            textStyle: {
              fontSize: 16,
              color: '#505050', //Y轴内容文字颜色
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            //y轴线的配置
            show: false,
            lineStyle: {
              color: '#505050',
              width: 1, //y轴线的宽度
              type: 'solid', //y轴线为实线
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              width: 0.5,
              color: 'rgba(255, 255, 255, 0.4)',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            data: data,
            name: this.getLanguageValue('营业收入'),
            type: 'bar',
            barWidth: '15px',
            itemStyle: {
              color: '#2BA8CD',
            },
          },
        ],
      }
      LeftChart.setOption(option)
    },
    getRightChart(data1) {
      // console.log(data1);
      const RightChart = this.$echarts.init(document.getElementById('rightChart1'))
      const option = {
        title: {
          text: this.getLanguageValue('累计所得税后净现金流量'),
          left: 'center',
          textStyle: {
            fontSize: '22',
            color: '#505050',
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
          axisPointer: {
            type: 'shadow',
          },
          axisLabel: {
            textStyle: {
              fontSize: 16,
              color: '#505050',
            },
          },
        },
        yAxis: {
          type: 'value',
          name: this.getLanguageValue('单位:万元'),
          nameTextStyle: {
            color: '#505050',
            fontSize: 16,
          },
          axisLabel: {
            //y轴文字的配置
            textStyle: {
              fontSize: 16,
              color: '#505050', //Y轴内容文字颜色
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            //y轴线的配置
            show: false,
            lineStyle: {
              color: '#505050',
              width: 1, //y轴线的宽度
              type: 'solid', //y轴线为实线
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              width: 0.5,
              color: 'rgba(255, 255, 255, 0.4)',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            data: data1,
            name: this.getLanguageValue('累计所得税后净现金流量'),
            type: 'bar',
            barWidth: '15px',
            itemStyle: {
              color: '#2BA8CD',
            },
          },
        ],
      }
      RightChart.setOption(option)
    },
    getFormCount(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log('error submit!!')
          return
        } else {
          this.getFormCount1()
        }
      })
    },
    getFormCount1() {
      this.loadingCount = true
      const {
        hasInternetPrice,
        corrected,
        oneChargeMonth,
        twoChargeMonth,
        chargePriceTwo,
        tenYearsReplaceBatter,
        viewProduct,
        hasElectPrice,
        electPrice,
        electRate,
        electYear,
      } = this.formBase
      const info = this.formBase?.listData || {}
      let data = {
        componentSpecification: info.componentStandard || '',
        componentPrice1: this.formBase.price,
        province: this.formBase.province,
        city: this.formBase.city,
        roofType: this.formBase.type == '1' ? '彩钢瓦屋面' : '混凝土屋面',
        houseSpace: this.formBase.roofArea,
        capacityCalcType: this.formBase.capacityCalcType,
        installCapacity: this.formBase.capacityCalcType !== '自动计算' ? this.formBase.installCapacity : '',
        systemType: this.formBase.costWay,
        systemCost: this.formBase.cost,
        selfElectricity: this.formBase.elecPrice,
        electricityDiscount: this.formBase.elecDiscount,
        electricityAutoRate: this.formBase.elecPower,
        voltage: this.formBase.voltage,
        componentInclination: this.formBase.angle.toString(),
        bulidType: this.formBase.invest,
        houseRent: this.formBase.roofRent,
        isEss: this.formBase.energyStorage,
        capacityRate: this.formBase.capacityRate,
        essTime: this.formBase.essTime,
        chargePrice: this.formBase.chargePrice,
        isCharge: this.formBase.isCharge,
        dischargePriceOne: this.formBase.dischargePriceOne,
        isEssSubsidy: this.formBase.isEssSubsidy,
        essSubsidy: this.formBase.essSubsidy,
        dischargeSubsidy: this.formBase.dischargeSubsidy,
        dischargeSubsidyYear: this.formBase.dischargeSubsidyYear,
        essSubsidyMax: this.formBase.essSubsidyMax,
        dischargeSubsidyMax: this.formBase.dischargeSubsidyMax,
        // dischargeCount:this.formBase.dischargeCount,
        dischargePriceTwo: this.formBase.dischargePriceTwo,
        pcPhone: '1', //(备注1pc  2手机)
        hasInternetPrice,
        internetPrice: hasInternetPrice === '用户设置' ? this.formBase.internetPrice : '',
        corrected,
        oneChargeMonth,
        twoChargeMonth,
        chargePriceTwo,
        tenYearsReplaceBatter,
        hasElectPrice,
      }
      if (hasElectPrice === '是') {
        data.electPrice = electPrice
        data.electRate = electRate
        data.electYear = electYear
      }
      data.component = Object.assign({}, info, { id: info && String(info.id).startsWith('custom-') ? null : info.id })
      CommercialResult(data).then((res) => {
        this.loadingCount = false
        if (res.success) {
          this.showResult = true
          this.formResult = res.data
          this.logId = res.data.logId
          // Vue.nextTick 主动触发一下图表，使之强制渲染
          this.$nextTick(() => {
            this.getLeftChart(res.data.busIncomeList)
            this.getRightChart(res.data.afterTaxAddList)
          })
        } else {
          this.$message.error(this.getLanguageValue(res?.message || '计算错误'))
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.handle-input-item {
  width: 240px;
}
.handle-imgs {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  margin-bottom: 16px;
}
.handle-input {
  width: 280px;
}
.handle-select {
  width: 280px;
}
.handle-radio {
  margin-left: 50px;
}
.two-columns {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
}

.flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.row-select-product {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
}
</style>
